import {Input, Select} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import {Grid} from 'src/design/atoms/Grid';
import React, {useMemo} from 'react';
import {RiskAssessmentCodeAreaEnum} from 'src/api/ProactApiClient';
import {SectionCard} from 'src/design/atoms/SectionCard';
import type {IFormDataV2} from 'src/types/FormV2';
import {mapEnumToSelectOption} from 'src/utilities/enumUtils';

const AreaOptions = mapEnumToSelectOption(RiskAssessmentCodeAreaEnum);

export interface GeneralSectionProps {
  formData: IFormDataV2;
  onChange: (name: string, value: any) => void;
  mode: 'create' | 'edit' | 'view';
  errors?: Record<string, string>;
}

export const GeneralSection: React.FC<GeneralSectionProps> = ({
  formData,
  onChange,
  mode,
  errors,
}) => {
  const selectData = useMemo(
    () =>
      AreaOptions.map(opt => ({
        value: String(opt.id),
        label: opt.label,
      })),
    []
  );

  if (mode === 'view') {
    return null;
  }

  return (
    <SectionCard title="General" data-testid="section-general">
      <Box p="md">
        <Grid gutter="md">
          <Grid.Col span={{base: 12, md: 6}}>
            <Input.Wrapper
              data-testid="form-field-name"
              label="Name"
              description="A descriptive name for this risk assessment code."
              error={errors?.name}
              withAsterisk>
              <Input
                data-testid="form-field-name-input"
                value={formData.name || ''}
                onChange={e => onChange('name', e.currentTarget.value)}
                placeholder="Enter risk assessment code name"
                error={!!errors?.name}
                autoComplete="new-password"
              />
            </Input.Wrapper>
          </Grid.Col>
          <Grid.Col span={{base: 12, md: 6}}>
            <Select
              data-testid="form-field-area"
              label="Risk Assessment Area"
              description="The area this code applies to."
              value={formData.area ? String(formData.area) : null}
              onChange={val => onChange('area', val || '')}
              data={selectData}
              placeholder="Select an area"
              withAsterisk
              error={errors?.area}
              comboboxProps={{zIndex: 1001}}
            />
          </Grid.Col>
        </Grid>
      </Box>
    </SectionCard>
  );
};
